import { defineMessages } from 'react-intl';

export default defineMessages({
  description: {
    id: 'app.components.PhotosphereContent.description',
    defaultMessage: 'Escreva qual o cômodo',
  },
  title: {
    id: 'app.components.PhotosphereContent.title',
    defaultMessage: '{photos, plural, one {foto 360 carregada} other {fotos 360 carregadas}}',
  },
  photoTitle: {
    id: 'app.components.PhotoManagerContent.photoTitle',
    defaultMessage: '{photos, plural, one {foto carregada} other {fotos carregadas}}',
  },
  deleteIconTooltip: {
    id: 'app.components.PhotosphereContent.DeleteIcon.ToolTip',
    defaultMessage: 'Excluir foto',
  },
  RotateIconTooltip: {
    id: 'app.components.PhotosContent.RotateIcon.ToolTip',
    defaultMessage: 'Girar foto',
  },
  selectMainIconTooltip: {
    id: 'app.components.PhotosContent.SelectMainIcon.ToolTip',
    defaultMessage: 'Definir capa',
  },
  autocomplete: {
    id: 'app.components.PhotosContent.Autocomplet',
    defaultMessage: 'controllable-autocomplete',
  },
});

